import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { Container } from '@mui/material';
import React from 'react';
import { InboxWidget } from './index';

export default (): React.ReactElement => {
    return (
        <Container maxWidth='sm'>
            <InboxWidget
                title='Inbox widget example'
                actionTitle='View all'
                onActionClick={() => {
                    showAlertSnackbar({ message: 'This is example of action click', type: 'info' });
                }}
                onRowActionClick={(notification) => {
                    showAlertSnackbar({ message: `Notification ${notification.id}`, type: 'info' });
                }}
                refreshIntervalInMinutes={1}
            />
        </Container>
    );
};


export const src = "import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';\nimport { Container } from '@mui/material';\nimport React from 'react';\nimport { InboxWidget } from './index';\n\nexport default (): React.ReactElement => {\n    return (\n        <Container maxWidth='sm'>\n            <InboxWidget\n                title='Inbox widget example'\n                actionTitle='View all'\n                onActionClick={() => {\n                    showAlertSnackbar({ message: 'This is example of action click', type: 'info' });\n                }}\n                onRowActionClick={(notification) => {\n                    showAlertSnackbar({ message: `Notification ${notification.id}`, type: 'info' });\n                }}\n                refreshIntervalInMinutes={1}\n            />\n        </Container>\n    );\n};\n";